module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('user-select', {
    attrs: {
      "placeholder": "Spieler suchen",
      "type": "all"
    },
    on: {
      "input": _vm.searchUser
    },
    model: {
      value: (_vm.searchedUser),
      callback: function($$v) {
        _vm.searchedUser = $$v
      },
      expression: "searchedUser"
    }
  })], 1), _vm._v(" "), (_vm.running_tournaments.length > 0) ? _c('section', [_c('h2', [_vm._v("Turniere")]), _vm._v(" "), _vm._l((_vm.running_tournaments), function(inv) {
    return _c('router-link', {
      key: inv.id,
      staticClass: "item",
      attrs: {
        "to": ("tournament/" + (inv.tournament_id))
      }
    }, [_c('img', {
      staticClass: "tournament",
      attrs: {
        "src": "images/tournament-dark.png"
      }
    }), _vm._v(" "), _c('h3', [_vm._v("\n                " + _vm._s(inv.tournament.name) + "\n            ")]), _vm._v(" "), _c('small', [_vm._v("\n                " + _vm._s(_vm._f("tournament_status")(inv.tournament.status)) + "\n            ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.invitations.length > 0) ? _c('section', [_c('h2', [_vm._v("Erhaltene Anfragen")]), _vm._v(" "), _vm._l((_vm.invitations), function(req) {
    return _c('div', {
      staticClass: "item"
    }, [(req.kind == 'match') ? [_c('dp', {
      attrs: {
        "who": req.player_a
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(req.player_a.firstname + ' ' + req.player_a.lastname))]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-secondary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.acceptMatch(req)
        }
      }
    }, [_vm._v("Akzeptieren")])] : [_c('img', {
      staticClass: "tournament",
      attrs: {
        "src": "images/tournament-dark.png"
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(req.tournament.name))]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-secondary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.acceptTournament(req)
        }
      }
    }, [_vm._v("Akzeptieren")])]], 2)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.friendRequests.length > 0) ? _c('section', [_c('h2', [_vm._v("Freundschaftsanfragen")]), _vm._v(" "), _vm._l((_vm.friendRequests), function(req) {
    return (req.user_b.friendship !== null) ? _c('div', {
      staticClass: "item"
    }, [
      [_c('dp', {
        attrs: {
          "who": req.user_b
        }
      }), _vm._v(" "), _c('h3', [_c('user-link', {
        attrs: {
          "who": req.user_b
        }
      })], 1), _vm._v(" "), _c('friendship-button', {
        attrs: {
          "who": req.user_b
        }
      })]
    ], 2) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.myMatches.length > 0) ? _c('section', [_c('h2', [_vm._v("Geplante Spiele")]), _vm._v(" "), _vm._l((_vm.myMatches), function(req) {
    return _c('div', {
      staticClass: "item"
    }, [(!req.tournament) ? [_c('dp', {
      attrs: {
        "who": req.player_a_id == _vm.user.id ? req.player_b : req.player_a
      }
    }), _vm._v(" "), (req.player_a_id == _vm.user.id) ? _c('h3', [_vm._v("\n                    " + _vm._s(req.player_b.firstname + ' ' + req.player_b.lastname) + "\n                ")]) : _c('h3', [_vm._v("\n                    " + _vm._s(req.player_a.firstname + ' ' + req.player_a.lastname) + "\n                ")]), _vm._v(" "), (req.status == 'ready') ? _c('a', {
      staticClass: "btn btn-secondary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.submitScore(req)
        }
      }
    }, [_vm._v("Spielen")]) : (req.status == 'requested') ? _c('a', {
      staticClass: "btn btn-secondary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.retractMatchRequest(req)
        }
      }
    }, [_vm._v("\n                   Anfrage zurückziehen\n               ")]) : (req.status == 'confirming' && (req.scored_by == 'a' && req.player_a_id == _vm.user.id || req.scored_by == 'b' && req.player_b_id == _vm.user.id)) ? _c('small', [_vm._v("\n                    Ergebnis wird geprüft\n                ")]) : _c('a', {
      staticClass: "btn btn-secondary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.submitScore(req)
        }
      }
    }, [_vm._v("\n                    Ergebnis prüfen\n                ")])] : [_c('dp', {
      attrs: {
        "who": req.player_a_id == _vm.user.id ? req.player_b : req.player_a
      }
    }), _vm._v(" "), (req.player_a_id == _vm.user.id) ? _c('h3', [_vm._v("\n                    " + _vm._s(req.player_b.firstname + ' ' + req.player_b.lastname) + "\n                ")]) : _c('h3', [_vm._v("\n                    " + _vm._s(req.player_a.firstname + ' ' + req.player_a.lastname) + "\n                ")]), _vm._v(" "), _c('small', [_vm._v("\n                    Teil eines Turniers\n                    "), (req.type != 'regular') ? [_vm._v("\n                        (Ausscheidungsphase)\n                    ")] : _vm._e()], 2), _vm._v(" "), (req.status == 'ready') ? [(req.tournament.status == 'in-progress') ? _c('a', {
      staticClass: "btn btn-secondary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.submitScore(req)
        }
      }
    }, [_vm._v("Spielen")]) : _c('small', [_vm._v("Warten auf Turnierbeginn")])] : (req.status == 'confirming' && (req.scored_by == 'a' && req.player_a_id == _vm.user.id || req.scored_by == 'b' && req.player_b_id == _vm.user.id)) ? _c('small', [_vm._v("\n                    Ergebnis wird geprüft\n                ")]) : _c('a', {
      staticClass: "btn btn-secondary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.submitScore(req)
        }
      }
    }, [_vm._v("\n                    Ergebnis prüfen\n                ")])]], 2)
  })], 2) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "activities"
  }, [_c('header', [_c('h2', [_vm._v("Benachrichtigungen")]), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn-secondary",
    attrs: {
      "to": "/notifications"
    }
  }, [_vm._v("\n                    Archiv\n                ")]), _vm._v(" "), (_vm.notifications.length > 0) ? _c('a', {
    staticClass: "btn-secondary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearNotifications()
      }
    }
  }, [_vm._v("\n                    Als gelesen markieren\n                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('notifications', {
    attrs: {
      "notifications": _vm.notifications
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "activities"
  }, [_c('header', [_c('h2', [_vm._v("Aktivität")]), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "btn-primary post",
    attrs: {
      "to": "/post"
    }
  }, [_vm._v("\n                    Posten\n                ")])], 1)]), _vm._v(" "), _c('timeline', {
    attrs: {
      "activities": _vm.activities
    }
  }), _vm._v(" "), _c('infinite-loading', {
    on: {
      "infinite": _vm.scrollHandler
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("\n                Hier ist noch nichts los :("), _c('br'), _vm._v("\n                Füge Freunde hinzu oder trage Spiele ein, um das zu ändern!\n            ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("\n                Ende der Aktivitäten\n            ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60a320c6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
// module id = 230
// module chunks = 0